// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AiSuggestion_DispositiveProvisionFragment } from './aiDP.generated';
import { gql } from '@apollo/client';
import { AiSuggestion_DispositiveProvisionFragmentDoc } from './aiDP.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchDispositiveProvisionSuggestionsV2QueryVariables = Types.Exact<{
  targetId: Types.Scalars['ID']['input'];
  isEntity: Types.Scalars['Boolean']['input'];
  isTestamentaryEntity: Types.Scalars['Boolean']['input'];
}>;


export type FetchDispositiveProvisionSuggestionsV2Query = { __typename?: 'Query', entityDPSuggestions?: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & AiSuggestion_DispositiveProvisionFragment
      ) | null } | null> | null }, testamentaryEntityDPSuggestions?: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & AiSuggestion_DispositiveProvisionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchDispositiveProvisionSuggestionsV2: 'FetchDispositiveProvisionSuggestionsV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchDispositiveProvisionSuggestionsV2Document = gql`
    query FetchDispositiveProvisionSuggestionsV2($targetId: ID!, $isEntity: Boolean!, $isTestamentaryEntity: Boolean!) {
  entityDPSuggestions: aiSuggestions(
    where: {kindIn: [DP_RECIPIENT_V2], or: [{acceptanceStatusIsNil: true}, {acceptanceStatus: ACCEPTED}, {acceptanceStatus: AUTO_ACCEPTED}], hasEntityWith: {id: $targetId}}
  ) @include(if: $isEntity) {
    edges {
      node {
        ...AISuggestion_DispositiveProvision
      }
    }
  }
  testamentaryEntityDPSuggestions: aiSuggestions(
    where: {kindIn: [DP_RECIPIENT_V2], or: [{acceptanceStatusIsNil: true}, {acceptanceStatus: ACCEPTED}, {acceptanceStatus: AUTO_ACCEPTED}], hasTestamentaryEntityWith: {id: $targetId}}
  ) @include(if: $isTestamentaryEntity) {
    edges {
      node {
        ...AISuggestion_DispositiveProvision
      }
    }
  }
}
    ${AiSuggestion_DispositiveProvisionFragmentDoc}`;

/**
 * __useFetchDispositiveProvisionSuggestionsV2Query__
 *
 * To run a query within a React component, call `useFetchDispositiveProvisionSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchDispositiveProvisionSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDispositiveProvisionSuggestionsV2Query({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      isEntity: // value for 'isEntity'
 *      isTestamentaryEntity: // value for 'isTestamentaryEntity'
 *   },
 * });
 */
export function useFetchDispositiveProvisionSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>(FetchDispositiveProvisionSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useFetchDispositiveProvisionSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>(FetchDispositiveProvisionSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchDispositiveProvisionSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>(FetchDispositiveProvisionSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type FetchDispositiveProvisionSuggestionsV2QueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsV2Query>;
export type FetchDispositiveProvisionSuggestionsV2LazyQueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsV2LazyQuery>;
export type FetchDispositiveProvisionSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsV2SuspenseQuery>;
export type FetchDispositiveProvisionSuggestionsV2QueryResult = Apollo.QueryResult<FetchDispositiveProvisionSuggestionsV2Query, FetchDispositiveProvisionSuggestionsV2QueryVariables>;